import { Link } from "react-router-dom";
import { services } from "../../../mocks/services";

const previewServices = services.slice(0, 3);

export default function ServicesPreview() {
  return (
    <section className="py-20 bg-[#F8F7F4]">
      <div className="max-w-screen-xl mx-auto px-6 md:px-10">
        {/* Header */}
        <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-6 mb-12">
          <div>
            <p className="text-[#6B7F5C] text-sm font-semibold uppercase tracking-widest mb-3">Nuestros Servicios</p>
            <h2 className="text-3xl md:text-5xl font-bold text-[#1A1A1A] leading-tight" style={{ fontFamily: "'Playfair Display', serif" }}>
              Soluciones para cada
              <span className="block">necesidad empresarial</span>
            </h2>
          </div>
          <p className="text-[#6B6B6B] text-base leading-relaxed max-w-md">
            Ofrecemos asesoramiento integral adaptado a empresas, autónomos y particulares con resultados garantizados.
          </p>
        </div>

        {/* Service cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-10">
          {previewServices.map((service) => (
            <div
              key={service.id}
              className="bg-white rounded-2xl overflow-hidden group hover:-translate-y-1 transition-transform duration-300"
            >
              {/* Image */}
              <div className="relative h-48 overflow-hidden">
                <img
                  src={service.image}
                  alt={service.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent" />
                <div className="absolute top-4 left-4 w-10 h-10 bg-white/90 rounded-lg flex items-center justify-center">
                  <i className={`${service.icon} text-[#6B7F5C] text-lg`} />
                </div>
              </div>
              {/* Content */}
              <div className="p-6">
                <h3 className="text-lg font-bold text-[#1A1A1A] mb-2" style={{ fontFamily: "'Playfair Display', serif" }}>
                  {service.title}
                </h3>
                <p className="text-[#6B6B6B] text-sm leading-relaxed mb-4 line-clamp-3">
                  {service.description}
                </p>
                <Link
                  to="/servicios"
                  className="flex items-center gap-1 text-[#6B7F5C] text-sm font-medium hover:gap-2 transition-all cursor-pointer"
                >
                  Más información
                  <div className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-arrow-right-line" />
                  </div>
                </Link>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center">
          <Link
            to="/servicios"
            className="inline-flex items-center gap-2 border-2 border-[#6B7F5C] text-[#6B7F5C] hover:bg-[#6B7F5C] hover:text-white font-semibold px-8 py-3.5 rounded-lg transition-all duration-200 cursor-pointer whitespace-nowrap"
          >
            Ver todos los servicios
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-line" />
            </div>
          </Link>
        </div>
      </div>
    </section>
  );
}
